import { EventDto } from 'defs/events';
import { MySuccessActionType } from './mySuccess.actionCreators';
import { MY_SUCCESS_LOADING, RECEIVED_MY_SUCCESS_ITEMS, RECEIVED_MY_SUCCESS_LEVELS } from './mySuccess.actionTypes';

export type MySuccessContentsType = {
	points: number;
	coach: string;
	level: string;
	badges: any;
	longestRunBadges: EventDto[];
	longestRunCurrent: number;
	longestRunRecord: number;
	nextLevelThreshold: number;
	numberOfRecipesDone: number;
	numberOfSpecialBadgesAwarded: number;
	numberOfSpecialBadgesExist: number;
	numberOfTipsDone: number;
	numberOfTodosDone: number;
	numberOfTotalDone: number;
	numberOfWorkoutsDone: number;
	numberToNextRecipesBadge: number;
	numberToNextTipBadge: number;
	numberToNextTodoBadge: number;
	numberToNextWorkoutBadge: number;
	underweightThreshold: number;
	weightCurrent: number;
	weightRecord: number;
	totalNumberBadges: EventDto[];
	recipeBadges: EventDto[];
	weightBadges: EventDto[];
	workoutBadges: EventDto[];
	specialBadges: EventDto[];
	tipBadges: EventDto[];
	todoBadges: EventDto[];
};

export type MySuccessStateType = {
	isLoading: boolean;
	allLevels: Array<Object> | null;
} & MySuccessContentsType;

export type RootStateType = {
	mySuccess: MySuccessStateType;
};

export type Progress1Type = {
	current: number;
	record: number;
	badges: number;
	maxThreshold: number;
};

export type Progress2Type = {
	i18n: string;
	current: number;
	next: Array<EventDto>;
	badges: Array<EventDto>;
	maxThreshold: number;
};

export type ProgressTodosType = {
	i18n: string;
	current: number;
	next: number;
	badges: Array<EventDto>;
	maxThreshold: number;
};

export type ProgressDataType = {
	total: {
		badges: Array<EventDto>;
	};
	longestRun: Progress1Type;
	weight: Progress1Type;
	thresholds: {
		nextLevel: number;
		underweight: number;
	};
	recipes: Progress2Type;
	tips: Progress2Type;
	todos: ProgressTodosType;
	workouts: Progress2Type;
	tasks: Progress2Type;
};

// Reducer
// ------------------------------------

export const initialState: Partial<MySuccessStateType> = {
	isLoading: false,
	points: null as any,
	nextLevelThreshold: null as any,
	coach: null as any,
	level: null as any,
	badges: [],
	allLevels: null,
	recipeBadges: [],
	specialBadges: [],
	tipBadges: [],
	todoBadges: [],
	totalNumberBadges: [],
	weightBadges: [],
	workoutBadges: [],
};

export default (state: MySuccessStateType = initialState as any, action: MySuccessActionType) => {
	switch (action.type) {
		case MY_SUCCESS_LOADING:
			return {
				...state,
				isLoading: true,
			};
		case RECEIVED_MY_SUCCESS_ITEMS:
			return {
				...state,
				isLoading: false,

				points: action.contents.points,
				coach: action.contents.coach,
				level: action.contents.level,

				longestRunBadges: action.contents.longestRunBadges,
				longestRunCurrent: action.contents.longestRunCurrent,
				longestRunRecord: action.contents.longestRunRecord,

				nextLevelThreshold: action.contents.nextLevelThreshold,
				underweightThreshold: action.contents.underweightThreshold,

				numberOfSpecialBadgesAwarded: action.contents.numberOfSpecialBadgesAwarded,
				numberOfSpecialBadgesExist: action.contents.numberOfSpecialBadgesExist,

				numberOfRecipesDone: action.contents.numberOfRecipesDone,
				numberOfTipsDone: action.contents.numberOfTipsDone,
				numberOfTodosDone: action.contents.numberOfTodosDone,
				numberOfWorkoutsDone: action.contents.numberOfWorkoutsDone,
				numberOfTotalDone: action.contents.numberOfTotalDone,

				numberToNextRecipesBadge: action.contents.numberToNextRecipesBadge,
				numberToNextTipBadge: action.contents.numberToNextTipBadge,
				numberToNextTodoBadge: action.contents.numberToNextTodoBadge,
				numberToNextWorkoutBadge: action.contents.numberToNextWorkoutBadge,

				weightCurrent: action.contents.weightCurrent,
				weightCurrentDiff: action.contents.weightDifferenceCurrent,
				weightRecord: action.contents.weightRecord,
				weightRecordDiff: action.contents.weightDifferenceRecord,

				recipeBadges: action.contents.recipeBadges,
				specialBadges: action.contents.specialBadges,
				tipBadges: action.contents.tipBadges,
				todoBadges: action.contents.todoBadges,
				totalNumberBadges: action.contents.totalNumberBadges,
				weightBadges: action.contents.weightBadges,
				workoutBadges: action.contents.workoutBadges,
			};
		case RECEIVED_MY_SUCCESS_LEVELS:
			return {
				...state,
				allLevels: action.allLevels,
			};
		default:
			return state;
	}
};

// Action Creators
// ------------------------------------

// Selectors
// ------------------------------------
